import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Endpoints } from '../enums/endpoints.enums';
import { HttpService } from './http.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ContactService {

    public recipeSelected = new BehaviorSubject<any>('');

    constructor(
        private httpService: HttpService,
        private httpClient: HttpClient 
    ) { }

    saveForm(request){
        const url = environment.apiUrl + Endpoints.SEND_PROFESIONALS;
        const options = this.httpService.headerOptionsJson(true, false);
        return this.httpClient.post<any>(url, request, options); 
    }

    sendConsult(request){
        const url = environment.apiUrl + Endpoints.SEND_CONSULT;
        const options = this.httpService.headerOptionsJson(true, false);
        return this.httpClient.post<any>(url, request, options); 
    }

    get getRecipeSelected(): any {
        return this.recipeSelected.getValue();
    }

}
